import BlogsList from "./BlogsList";
import LandingPage from "./LandingPage";

function MainPage() {
    return (
        <>
            <LandingPage />
            <BlogsList />
        </>
    );
}

export default MainPage;